import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext({ isDark: true, toggle: () => {} });

export const ThemeProvider = ({ children }) => {
  // Default to dark; read from localStorage if available
  const [isDark, setIsDark] = useState(() => {
    try {
      const saved = localStorage.getItem('avarnix-theme');
      if (saved !== null) return saved === 'dark';
    } catch (_) {}
    return true; // default dark
  });

  // Apply / remove 'dark' class on <html>
  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    try { localStorage.setItem('avarnix-theme', isDark ? 'dark' : 'light'); } catch (_) {}
  }, [isDark]);

  const toggle = () => setIsDark(v => !v);

  return (
    <ThemeContext.Provider value={{ isDark, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;
